import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataManagerSearch`

export default defineMessages({
  manualSearchPrompt: {
    id: `${scope}.manualSearchPrompt`,
    defaultMessage: 'Press Enter to search',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search...',
  },
  updateSearchButtonLabel: {
    id: `${scope}.updateSearchButtonLabel`,
    defaultMessage: 'Update search',
  },
  categorySelectPlaceholder: {
    id: `${scope}.categorySelectPlaceholder`,
    defaultMessage: 'All',
  },
})
